import { HpDispatchFunction } from '../types';
import { HpFluentAnswerClickPayload } from './fluentAnswerClickActionTypes';

export function fluentAnswerClickAction(payload: HpFluentAnswerClickPayload) {
  return (dispatch: HpDispatchFunction<HpFluentAnswerClickPayload>): void => {
    dispatch({ type: 'FLUENT_ANSWER_CLICK', payload });
  };
}
